// @flow

import { isBuilderPreviewRequest } from "./URL";

const BUILDER_PREVIEW_STORAGE_PREFIX = "builder-preview-";

export function getFormViewStorageKey(formID: string): string {
  return isBuilderPreviewRequest()
    ? `${BUILDER_PREVIEW_STORAGE_PREFIX}${formID}`
    : formID;
}

export function getSubmittedFormViewStorageKey(formID: string): string {
  return `submitted-${getFormViewStorageKey(formID)}`;
}
